<template>
  <div>
    <iframe
      id="_mainIframe"
      src="https://account.xkw.com/#/index/editPassword?csshref=//zxxkstatic.zxxk.com/usercenter/skins/css/account.css"
      :height="windowHeight + 'px'"
      width="1200px"
      scrolling="no"
      frameborder="0"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: 0,
    };
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    window.addEventListener(
      "message",
      function (event) {
        var data = event.data;
        // console.log("data-----------", data);
        let frm = document.getElementById("_mainIframe");
        if (typeof data == "string") {
          if (data.indexOf("height") > -1) {
            var idx = data.indexOf(":");
            frm.setAttribute(
              "height",
              parseInt(data.substring(idx + 1, data.length))
            );
          }
        }
      },
      false
    );
  },
};
</script>
<style lang="scss" scoped>
iframe {
  margin: 0 auto;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 48px;
}
</style>
